import { render, staticRenderFns } from "./UsersDataCongratulation.vue?vue&type=template&id=5f64be38&"
import script from "./UsersDataCongratulation.vue?vue&type=script&lang=js&"
export * from "./UsersDataCongratulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports